import MediationRequests from "./pages/mediation-requests/store";
import Transactions from "./pages/transactions/store";

export default {
  namespaced: true,
  modules: {
    MediationRequests,
    Transactions
    
  },
};
